import { useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'

import styles from './styles.module.scss'

import { InstitutionRepository } from '../../admin/repositories/institution.repository'
import { useDownload } from '@/pages/@hooks/use-download'
import { StorageService } from '@/services/storage'
import { Loader } from '@/components/Loader'

interface IPartner {
  url_image: string
  name: string
  id: number
}

const storageService = new StorageService()

export function Partners() {
  const { download, isLoadingDownload } = useDownload({ storageService })
  const [slidesPerView, setSlidesPerView] = useState(6)
  const [partners, setPartners] = useState<IPartner[]>([])

  useEffect(() => {
    const getInstitutes = async () => {
      const courses = await InstitutionRepository.GetInstance().listRandom('2')

      const coursesFormatted =
        courses
          ?.filter((c) => !!c && c?.logo && c.active)
          .map((c) => ({
            url_image: download(c.logo),
            name: c.title,
            id: c.id,
          })) || []

      const images = await Promise.all(
        coursesFormatted
          .filter((course) => !!course?.url_image)
          .map((course) => course?.url_image),
      )

      setPartners(
        coursesFormatted.map((course, index) => ({
          ...course,
          url_image: images[index][0]?.url || null,
          hasError: false,
        })),
      )
    }
    getInstitutes()
  }, [])

  useEffect(() => {
    const handleResize = () => {
      const count = () => {
        if (window.innerWidth > 850) return 6
        return window.innerWidth < 610 ? 3 : 4
      }
      setSlidesPerView(count())
    }

    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  }, [window.innerWidth])

  return (
    <div className={styles.container}>
      {isLoadingDownload && <Loader />}

      {partners?.length > 0 && (
        <Swiper
          slidesPerView={slidesPerView}
          slidesPerGroup={6}
          navigation
          pagination={{ clickable: true }}
          loop={true}
          className={styles.partners}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          speed={1000}
        >
          {partners?.length > 0 &&
            partners?.map((partner) => {
              return (
                <SwiperSlide key={partner.id}>
                  <img
                    src={partner.url_image}
                    alt={`${partner.name}`}
                    onError={(e) => {
                      const target = e.currentTarget
                      target.onerror = null
                      target.src = '/default_logo.png'
                    }}
                  />
                </SwiperSlide>
              )
            })}
        </Swiper>
      )}

      {partners?.length === 0 && <div>...carregando</div>}
    </div>
  )
}
